module.exports = __webpack_public_path__ + "static/media/14122018.69dfc9ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/14122018.png
// module id = 247
// module chunks = 0